import Container from '@/components/Container';
import { Typography } from '@mui/material';
import SwitchInput from '@/components/forms/SwitchInput';
import TextInput from '@/components/forms/TextInput';
import React from 'react';

interface SubjectKeywordsProps {
  blockPath: string;
  tComponents: (key: string) => string;
  filterEnabled: boolean;
}

const FilterSubjectKeywords: React.FC<SubjectKeywordsProps> = ({ blockPath, tComponents, filterEnabled }) => (
  <Container gap={0} fullWidth column right>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.SubjectKeywordsTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: 'auto' }}>
          <SwitchInput
            path={`${blockPath}.userCanFilterSubjectKeywords`}
            label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
          />
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <TextInput
        path={`${blockPath}.subjectKeywords`}
        label={tComponents('DMFilterSearch.InputLabelSubjectKeywords')}
      />
      {filterEnabled && (
        <div style={{ width: '30%' }}>
          <TextInput
            path={`${blockPath}.subjectKeywordsDropDownMenuTitle`}
            label={tComponents('DMFilterSearch.SubjectKeywordsDropDownMenuTitleLabel')}
          />
        </div>
      )}
    </Container>
  </Container>
);

export default FilterSubjectKeywords;
